import axios from "axios";

import axiosInstance from "../../services/AxiosInstance";
import { showErrorAlert } from "../../services/ErrorHandlingService";

// Action Types
export const FETCH_LEADS_START = "FETCH_LEADS_START";
export const FETCH_LEADS_SUCCESS = "FETCH_LEADS_SUCCESS";
export const FETCH_LEADS_ERROR = "FETCH_LEADS_ERROR";
export const GET_LEAD_DETAILS_REQUEST = "GET_LEAD_DETAILS_REQUEST";
export const GET_LEAD_DETAILS_SUCCESS = "GET_LEAD_DETAILS_SUCCESS";
export const GET_LEAD_DETAILS_FAILURE = "GET_LEAD_DETAILS_FAILURE";
export const UPDATE_LEAD_BRANCH_REQUEST = "UPDATE_LEAD_BRANCH_REQUEST";
export const UPDATE_LEAD_BRANCH_SUCCESS = "UPDATE_LEAD_BRANCH_SUCCESS";
export const UPDATE_LEAD_BRANCH_FAILURE = "UPDATE_LEAD_BRANCH_FAILURE";

// Action Creators
const fetchLeadsStart = (category) => ({
  type: FETCH_LEADS_START,
  payload: { category },
});

const fetchLeadsSuccess = (category, data) => ({
  type: FETCH_LEADS_SUCCESS,
  payload: { category, data },
});

const fetchLeadsError = (category, error) => ({
  type: FETCH_LEADS_ERROR,
  payload: { category, error },
});

// Thunk Action Creator
export const fetchLeads = (endpoint) => {
  return async (dispatch) => {
    const categoryMap = {
      FreshLeads: "freshleads",
      FollowupLeads: "followupleads",
      convertedbutNotMedicineTakenLeads: "convertednomedicine",
      TodaysFollowups: "todaysfollowups",
      TomorrowFollowups: "tomorrowfollowups",
      UpcomingFollowups: "upcomingfollowups",
    };
    
    const category = categoryMap[endpoint];
    dispatch(fetchLeadsStart(category));

    try {
      const response = await axiosInstance.post(`lead/${endpoint}`, {});

      dispatch(fetchLeadsSuccess(category, response.data.data));
    } catch (error) {
      showErrorAlert("Failed to fetch leads");
      dispatch(
        fetchLeadsError(category, error.response?.data || error.message)
      );
    }
  };
};
